<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import TopCard from "./top-card.svelte";
export let isBigScreen = false;
</script>

<a href={toSiteUrl('/vip/', $loggedIn) || '#'}>
	<div class="top-card-container">
		<TopCard
			backgroundImage={cfgToThemeCdnPath('/top-section/big-right.png')}
			height="100%"
			width="100%"
			backgroundImagePositionX="center"
		>
			<div class="content-top-card" slot="content"></div>
		</TopCard>
		<div class="vip-content">
			<h2 class="card-section-title">{$t(Verbiage.vip_club).toUpperCase()}</h2>
			<div class="description-container">
				<p class="card-section-body">{$t(Verbiage.vip_description)}</p>
			</div>
		</div>
	</div>
</a>

<style>
	a {
		height: 100%;
		width: 100%
}

	.content-top-card {
		position: relative;
		z-index: 50;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: flex-end;
		justify-content: space-between;
		padding: 1rem
}

	@media (min-width: 1280px) {
		.content-top-card {
				padding: 0.75rem
		}
	}

	@media (min-width: 1440px) {
		.content-top-card {
				padding: 1.25rem
		}
	}

	.top-card-container {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		cursor: pointer;
		align-items: center;
		justify-content: space-between
}

	.vip-content {
		position: absolute;
		z-index: 20;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-end;
		border-radius: 16px;
		padding: 0.75rem
}

	@media (min-width: 1280px) {
		.vip-content {
				padding: 0.75rem
		}
	}

	@media (min-width: 1440px) {
		.vip-content {
				padding: 1.25rem
		}
	}

	.card-section-title {
		font-size: 14px;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2)
}

	@media (min-width: 640px) {
		.card-section-title {
				font-size: 24px
		}
	}

	@media (min-width: 1280px) {
		.card-section-title {
				font-size: 18px;
			font-size: clamp(8px, 1.1cqi, 18px) !important
		}
	}

	.card-section-body {
		max-width: 90%;
		font-size: 9px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2);
		text-align: start !important;
		text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5)
}

	@media (min-width: 640px) {
		.card-section-body {
				font-size: 12px;
			font-size: clamp(8px, 0.8cqi, 12px) !important
		}
	}

	@media (min-width: 1600px) {
		.card-section-body {
				font-size: 14px
		}
	}
</style>
